import { Grid, TextField, Typography } from "@mui/material";
import EnforcementAppealsSearchState from "./EnforcementAppealsSearchState";
import "../Search.css";
import { EnforcementAppealsFilter } from "@shared/publicportal/contracts/EnforcementAppealsFilter";

interface EnforcementAppealsSimpleSearchProps {
    state: EnforcementAppealsSearchState;
    setter: (modifier: Partial<EnforcementAppealsFilter>) => void;
}

const EnforcementAppealsSimpleSearch = (props: EnforcementAppealsSimpleSearchProps) => {
    return (
        <Grid container className="search-container search-container-simple">
            <Grid size={{ xs: 12, md: 12, xl: 12 }}>
                <Typography variant="h5">Reference</Typography>
            </Grid>
            <Grid size={{ xs: 12, md: props.state.searchType === "Advanced" ? 6 : 12, xl: props.state.searchType === "Advanced" ? 4 : 12 }}>
                <TextField
                    name="appealRef"
                    value={props.state.filter.appealRef}
                    onChange={(event) => props.setter({ appealRef: event.target.value })}
                    key="enforcement-appeal-ref-key"
                    size="small"
                    id="enforcement-appeal-ref"
                    label="Appeal Reference"
                    variant="outlined"
                    className="min-width-18rem"
                />
            </Grid>
            <Grid size={{ xs: 12, md: props.state.searchType === "Advanced" ? 6 : 12, xl: props.state.searchType === "Advanced" ? 4 : 12 }}>
                <TextField
                    value={props.state.filter.noticeRef}
                    onChange={(event) => props.setter({ noticeRef: event.target.value })}
                    key="enforcement-appeal-notice-ref-key"
                    size="small"
                    id="aenforcement-appeal-notice-ref"
                    label="Notice Reference"
                    variant="outlined"
                    className="min-width-18rem"
                />
            </Grid>
            <Grid size={{ xs: 12, md: props.state.searchType === "Advanced" ? 6 : 12, xl: props.state.searchType === "Advanced" ? 4 : 12 }}>
                <TextField
                    value={props.state.filter.inspectorateRef}
                    onChange={(event) => props.setter({ inspectorateRef: event.target.value })}
                    key="enforcement-appeal-inspectorate-ref-key"
                    size="small"
                    id="enforcement-appeal-inspectorate-ref"
                    label="Inspectorate Reference"
                    variant="outlined"
                    className="min-width-18rem"
                />
            </Grid>
        </Grid>
    );
};

export default EnforcementAppealsSimpleSearch;
